import React from 'react';
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader';
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar';
import ShopManagementPageHero from '../../components/Shop/Layout/ShopManagementPageHero';
import CreateProduct from "../../components/Shop/CreateProduct";
import BulkProductUpload from "../../components/Shop/BulkProductUpload";
import ImportShopifyProductsModal from '../../components/Shop/ImportShopifyProductsModal';

const ShopCreateProduct = () => {
  return (
    <div className="shop-create-product-page-container">
      <DashboardHeader />
      <div className="shop-create-product-page-main shop-management-layout">
        <div className="shop-create-product-page-sidebar shop-management-sidebar-slot">
          <DashboardSideBar active={6} />
        </div>
        <main className="shop-create-product-page-content shop-management-main-panel">
          <ShopManagementPageHero
            eyebrow="Inventory"
            title="Create Products"
            copy="Build individual products or bring in catalog inventory with bulk import tools."
          />
          <div className="shop-create-product-page-header">
            <div className="shop-create-product-page-heading-group">
              <h3 className="shop-create-product-page-title">Product Tools</h3>
            </div>
            <div className="shop-create-product-page-upload">
              <BulkProductUpload />
              <ImportShopifyProductsModal />
            </div>
          </div>
          <CreateProduct />
        </main>
      </div>
    </div>
  );
};

export default ShopCreateProduct;
